








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { KonvaEventObject } from 'konva/types/Node';
import { getEventPoint, getEventsPoints } from '../utils/eventsUtils';
import { Evnt } from '../__types';

@Component
export default class Timeline extends Vue {
  @Prop(Number) readonly index!: number;
  @Prop(Array) readonly events!: Evnt[];
  @Prop(String) readonly color!: string;
  @Prop(Object) readonly firstEvent!: Evnt;
  @Prop(Number) readonly center!: number;

  setCurrentEventById(id: string) {
    this.$store.dispatch('events/setCurrentEventById', id);
  }

  get currentEvent() {
    return this.$store.getters['events/getCurrentEvent'];
  }

  eventPoints = getEventsPoints(this.events, 20);
  points = Object.keys(this.eventPoints).map(key => parseInt(key, 10));
  offset =
    getEventPoint(this.events[0], 20) - getEventPoint(this.firstEvent, 20);

  configTimeline = {
    x: this.offset,
    y: this.index * 20 + 50,
  };

  configBeginningLine = {
    x: 0,
    y: 0,
    points: [-window.innerWidth / 2, 0, 0, 0],
    strokeLinearGradientColorStops: [0, '#ffffff00', 1, this.color],
    strokeLinearGradientStartPoint: { x: -window.innerWidth / 2, y: 0 },
    strokeLinearGradientEndPoint: { x: 0, y: 0 },
    strokeWidth: 10,
  };

  configLine = {
    x: 0,
    y: 0,
    points: [0, 0, this.points[this.points.length - 1], 0],
    stroke: this.color,
    strokeWidth: 10,
  };

  configPoint = {
    y: this.configLine.y,
    fill: '#e8e8e8',
    shadowEnabled: true,
    shadowColor: 'rgba(0, 0, 0, 0.2)',
    shadowOffset: { x: -1, y: 1 },
    shadowBlur: 5,
  };

  changeCursor(e: KonvaEventObject<MouseEvent>, cursor: string): void {
    const container = e.target.getStage()?.container();
    if (container) container.style.cursor = cursor;
  }

  setCurrentEvent(e: Event, point: number) {
    this.setCurrentEventById(this.eventPoints[point].id);
  }
}
